var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":"/img/logos/controlsoft_logo_dark.png","position":(_vm.left ? 'left' : 'center') + ' center',"contain":"","height":_vm.h,"width":_vm.w,"max-height":_vm.mh,"max-width":_vm.mw,"min-height":_vm.h,"min-width":_vm.w}})}
var staticRenderFns = []

export { render, staticRenderFns }